import { diaryHomeToDoPath } from "@/features/diaries/routes";
import { createFileRoute, redirect } from "@tanstack/react-router";

/** Bare /home URL goes straight to the To Do tab. */
export const Route = createFileRoute("/_app/diaries/$diaryId/home/")({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: diaryHomeToDoPath,
            params: { diaryId: params.diaryId },
        });
    },
});
